import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./config.js";

const VAPID_KEY =
  "BMv_houx20lYpKJVmn3NbT1f5skq_hny47kwi1sWWNarOrYt7Klc3eeE3NzSLPhAG39R14woXo32B8NZKFxoz6I";

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const currentToken = await getToken(messaging, {
        vapidKey: VAPID_KEY, // from Firebase Console → Project Settings → Cloud Messaging
        serviceWorkerRegistration: await navigator.serviceWorker.ready,
      });
      //   console.log("✅ FCM Token:", currentToken);
      return currentToken;
    } else {
      console.warn("❌ Notification permission not granted.");
    }
  } catch (error) {
    console.error("❌ Error getting FCM token:", error);
  }
};

export const listenForMessages = (callback) => {
  return onMessage(messaging, (payload) => {
    console.log("FCM Foreground Message:", payload);
    callback(payload);
  });
};
